<template>
  <div style="margin-bottom: 100px">
    <p style="cursor: pointer; margin-bottom: 10px" @click="goBack()">
      <u>Back to companies</u>
    </p>
    <h1 v-bg-typography="'h1'">Add a new company</h1>
    <p class="error" v-if="displayError">{{ error }}</p>
    <bg-loader :dark="true" v-if="isLoading"></bg-loader>
    <div
      class="form"
      style="max-width: 500px; margin-top: 50px"
      v-if="!isLoading"
    >
      <div>
        <bg-field class="field" label="Company name" name="start">
          <bg-input v-model="newCompany.name" />
        </bg-field>
      </div>

      <div>
        <bg-field class="field" label="Address" name="start">
          <bg-input v-model="newCompany.address" />
        </bg-field>
      </div>

      <div style="display: flex; gap: 30px">
        <bg-field class="field" label="Postal code" name="start">
          <bg-input v-model="newCompany.postal" />
        </bg-field>

        <bg-field class="field" label="City" name="start">
          <bg-input v-model="newCompany.city" />
        </bg-field>
      </div>

      <div>
        <bg-field label="Country" name="country">
          <bg-select
            :options="countryOptions"
            label="name"
            :clearable="true"
            :searchable="true"
            :value="newCompany.country"
            @change="onCountryChange"
          ></bg-select>
        </bg-field>
      </div>

      <div>
        <bg-field label="Company admin" name="company_admin">
          <bg-select
            :options="adminOptions"
            :value="newCompany.admin"
            label="email"
            :clearable="true"
            :searchable="true"
            :loading="$store.state.users.loading"
            @change="onAdminChange"
          ></bg-select>
        </bg-field>
      </div>

      <div class="newUser" v-if="newUserMode">
        <bg-field class="field" label="Email address of new user" name="start">
          <bg-input v-model="newAdmin.email" />
        </bg-field>
      </div>

      <div>
        <bg-field label="Consultant" name="consultant">
          <bg-select
            :options="consultantOptions"
            :value="newCompany.consultant"
            label="email"
            :clearable="true"
            :searchable="true"
            @change="onConsultantChange"
            :loading="$store.state.users.loading"
          ></bg-select>
        </bg-field>
      </div>

      <div>
        <bg-field label="Account manager" name="accountmanager">
          <bg-select
            :options="consultantOptions"
            :value="newCompany.businessdeveloper"
            label="email"
            :loading="$store.state.users.loading"
            @change="onBmChange"
            :clearable="true"
            :searchable="true"
          ></bg-select>
        </bg-field>
      </div>

      <div>
        <bg-field
          label="Add a Brainpeek subscription (optional)"
          name="subscription"
        >
          <bg-select
            :options="contractOptions"
            label="text"
            :value="newCompany.contract"
            @change="onContractChange"
          ></bg-select>
        </bg-field>
      </div>

      <div>
        <bg-button
          variant="primary"
          text="Save"
          style="margin-right: 30px"
          @click="addCompany"
          :disabled="disabled"
        />
        <bg-button variant="secondary" text="Close" @click="goBack" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.error {
  padding: 20px 15px;
  background-color: #ff14a9;
  color: white;
  width: 500px;
  border-radius: 8px;
  font-weight: 600;
}
</style>

<script>
import BgTypography from "@/directives/bg-typography";
import BgField from "@/components/bg-field";
import BgInput from "@/components/bg-input";
import BgSelect from "@/components/bg-select";
import BgButton from "@/components/bg-button";
import BgLoader from "@/components/bg-loader";
import API from "@/api";
import moment from "moment";

export default {
  components: {
    BgInput,
    BgField,
    BgSelect,
    BgButton,
    BgLoader,
  },
  directives: {
    BgTypography,
  },
  props: [],
  created() {
    this.fetchData();
  },
  data() {
    return {
      countryOptions: [],
      contractOptions: [
        { text: "1 Month", value: 1 },
        { text: "3 Months", value: 3 },
        { text: "6 Months", value: 6 },
        { text: "1 Year", value: 12 },
        { text: "2 Years", value: 24 },
      ],
      displayError: false,
      error: "",
      isLoading: true,
      newAdmin: {
        firstname: "",
        lastname: "",
        email: "",
      },
      newCompany: {
        name: "",
        address: "",
        postal: "",
        city: "",
        country_id: "",
        contract: null,
        admin: "",
        consultant: "",
        businessdeveloper: "",
      },
      newUserMode: false,
    };
  },
  computed: {
    consultantOptions() {
      if (this.$store.state.users.users.length === 0) {
        return [];
      } else {
        return this.$store.state.users.users.filter((u) => {
          return (
            u.role === "admin" ||
            (u.role === "company_admin" && u.company.licence_research) ||
            (u.role === "company_member" && u.company.licence_research)
          );
        });
      }
    },
    adminOptions() {
      let list = ["Create new user"];
      if (this.$store.state.users.users.length === 0) {
        return list;
      } else {
        this.$store.state.users.users.map((i) => {
          if (i.role === "demo") {
            list.push(i);
          }
        });

        return list;
      }
    },
    disabled: function() {
      let newUser;
      if (this.newCompany.admin === "Create new user") {
        newUser = this.newAdmin.email;
      } else {
        newUser = true;
      }
      if (
        newUser &&
        this.newCompany.name &&
        this.newCompany.address &&
        this.newCompany.postal &&
        this.newCompany.city &&
        this.newCompany.country &&
        this.newCompany.admin &&
        this.newCompany.consultant &&
        this.newCompany.businessdeveloper
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    async addCompany() {
      this.isLoading = true;
      this.displayError = false;

      const newCompany = {
        company: {
          name: this.newCompany.name,
          address: this.newCompany.address,
          postal_code: this.newCompany.postal,
          city: this.newCompany.city,
          country_id: this.newCompany.country.id,
          consultant_id: this.newCompany.consultant.id,
          business_developer_id: this.newCompany.businessdeveloper.id,
        },
      };

      if (this.newUserMode) {
        newCompany.company.admin_email = this.newAdmin.email;
      } else {
        newCompany.company.admin_id = this.newCompany.admin.id;
      }

      const res = await API.user.createCompany(newCompany);
      let success = res.status === 200;
      if (!success) {
        this.isLoading = false;
        this.displayError = true;
        if (res.errors.hasOwnProperty("name")) {
          this.error =
            "This company name has already been taken. Please try another company name.";
        } else if (res.errors.hasOwnProperty("admin")) {
          this.error =
            "This admin (user) is already member to another company. Please try another user.";
        }
      }
      let companyId;
      if (success) {
        companyId = res.data.id;
      }
      if (this.newCompany.contract && success) {
        let start = moment().format("YYYY-MM-DD");
        let end = moment()
          .add(this.newCompany.contract.value, "month")
          .format("YYYY-MM-DD");

        const contract = {
          start_date: start,
          end_date: end,
          comments: "",
          company_id: companyId,
        };

        await API.user.createContract(contract);
      }

      if (success) {
        await this.$store.dispatch("fetchAllCompanies");
        this.$router.replace(`/admin/companies/${companyId}`);
      }
    },
    async fetchData() {
      this.isLoading = true;

      const countries = await API.test.getCountries();
      if (countries) {
        countries.countries.forEach((el) => this.countryOptions.push(el));
      }
      this.isLoading = false;
    },
    goBack() {
      this.$router.replace("/admin/companies");
    },
    onCountryChange(val) {
      this.newCompany.country = val;
    },
    onAdminChange(val) {
      this.newCompany.admin = val;
      if (val === "Create new user") {
        this.newUserMode = true;
      } else {
        this.newUserMode = false;
      }
    },
    onConsultantChange(val) {
      this.newCompany.consultant = val;
    },
    onBmChange(val) {
      this.newCompany.businessdeveloper = val;
    },
    onContractChange(val) {
      this.newCompany.contract = val;
    },
  },
};
</script>
